/* Lazy, gesture-gated AudioContext shared by the metronome, sfx, and mic
   analysis. Nothing in this module runs until first called from a click
   handler (iOS requires resume() inside a user gesture). */

let ctx: AudioContext | null = null;
let masterGain: GainNode | null = null;

export function getAudioContext(): AudioContext {
  if (!ctx) {
    const Ctor = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
    ctx = new Ctor();
    masterGain = ctx.createGain();
    masterGain.gain.value = 1;
    masterGain.connect(ctx.destination);
  }
  return ctx;
}

export function getMasterGain(): GainNode {
  getAudioContext();
  return masterGain!;
}

export function setMasterVolume(v: number): void {
  getMasterGain().gain.value = Math.max(0, Math.min(1, v));
}

/** Call from inside a click/tap handler before scheduling any sound. */
export async function resumeAudio(): Promise<void> {
  const c = getAudioContext();
  if (c.state === "suspended") {
    try {
      await c.resume();
    } catch {
      /* some browsers refuse resume() outside a fresh gesture — sound just stays silent */
    }
  }
}
